import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Button, Col, Form } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import Dropzone from 'react-dropzone'
import { useDispatch } from 'react-redux'
import XLSX from 'xlsx'

import ColetaClickstream from '../../../../components/clickstreamAnalise/clickstreamColeta.js'
import SpinerVeye from '../../../../components/spinnerVeye/spinnerVeye.js'
import { api_gateway } from '../../../../conexoes/api'
import { revelarSolicitacaBloquearVirtueyes } from '../../../../redux/actions/index'
import {
  adicionarMaisVerdeSemEllipse,
  elipseVerde,
  fecharJanela,
  importarArquivo,
  lixeiraVermelho,
  alertaVermelho
} from '../../../../utils/alternanciaIcones'
import decryptJWT from '../../../../utils/decryptJWT'
import MensagemAtencao from '../../../componentesModais/mensagens/mensagemAtencao'
import MensagemErro from '../../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../../componentesModais/mensagens/mensagemSucesso'
import '../../../../css/painelVirtueyes/solicitacaoBloqueio/bloquearCliente/bloquearCliente.css'

const iconeAlerta = (
  <img
    className="icone-alerta-filtro-arquivo"
    src={alertaVermelho()}
    alt="alerta"
  />
)

let atualizarParent = false

export default function BloquearCliente(props) {
  const [spinAtivo, setSpinAtivo] = useState(false)
  const [quantidadeLinhasSelecionados, setQuantidadeLinhasSelecionados] =
    useState(-1)
  const [enviarEmail, setEnviarEmail] = useState(false)
  const [linhaRemover, setLinhaRemover] = useState('')
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const [itens, setItens] = useState([])
  const [validacaoCliente, setValidacaoCliente] = useState(false)
  const [cliente, setCliente] = useState('')
  const [arquivo, setArquivo] = useState([])
  const [revelarValidacao, setRevelarValidacao] = useState(false)
  const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const despacho = useDispatch()
  const modal = useRef()

  let itensTemporarios = []

  const colunas = [
    {
      dataField: 'n0_codigo_cliente',
      text: 'Cód. cliente',
      headerClasses: 'tabela-transparente-cabecalho nao-selecionavel',
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'ds_pav_cliente',
      text: 'Razão social',
      headerClasses: 'tabela-transparente-cabecalho nao-selecionavel',
      sort: true,
      formatter: (cell) => {
        return (
          <p className="fonte-cor-1 label-tabela-1">
            {cell != '' ? cell : '-'}
          </p>
        )
      }
    },
    {
      dataField: 'cd_pav_cliente',
      text: '',
      headerClasses: 'centralizar tabela-coluna-ultima-header nao-selecionavel',
      classes: 'botoes-barra-acoes',
      formatter: (cell) => {
        return (
          <Button
            variant="danger"
            className="botoes-tabela-acoes"
            size="sm"
            onClick={() => handleRemoverLinha(cell)}
          >
            <img
              className="icone-botao-acao-tabela"
              src={lixeiraVermelho()}
              alt="remover-linha"
            />
          </Button>
        )
      }
    }
  ]

  const handleCancelar = useCallback(async () => {
    ColetaClickstream(1377) // 'dropAcoesSolicitacaBloquearVirtueyesCancelar'
    itensTemporarios = []
    setSpinAtivo(false)
    if (atualizarParent === true) {
      props.setRenderizar(!props.renderizar)
    }
    despacho(revelarSolicitacaBloquearVirtueyes(false))
  }, [props, despacho])

  const handleClickFora = useCallback(
    (e) => {
      if (!modal.current.contains(e.target)) {
        handleCancelar()
      }
    },
    [handleCancelar]
  )

  useEffect(() => {
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
  }, [handleClickFora])

  async function handlerConsultarArquivo() {
    if (arquivo.length > 0) {
      setSpinAtivo(true)
      Promise.all(
        arquivo.map(async (item_arquivo) => {
          setSpinAtivo(true)
          if (item_arquivo != '') {
            await api_gateway
              .get(
                '/m1/consultar/cliente?painel_virtueyes=true&flBloqueio=true&n0_codigo_cliente=' +
                  item_arquivo
              )
              .then((response) => {
                if (response.status == 200 && response.data.dados[0]) {
                  itensTemporarios.push(response.data.dados[0])
                }
              })
              .catch(() => {
                setMensagemErro(
                  'Erro na consulta de clientes, por favor verifique se o arquivo contem apenas numeros do cliente'
                )
                handleMensagemErro(false)
              })
          }
        })
      )
        .then(() => {
          setItens(itensTemporarios)
          handleLinhasSelecionadas(itensTemporarios.length)
        })
        .finally(() => {
          setSpinAtivo(false)
        })
    }
  }
  useEffect(() => {
    handlerConsultarArquivo()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arquivo])

  //Funcao para ler os dados do arquivo
  function handleLerArquivo(files) {
    files.forEach((file) => {
      const extensao = file?.name?.split('.')?.pop()?.toLowerCase()
      const formatosSuportados = ['csv', 'xls', 'xlsx', 'txt']

      if (!formatosSuportados.includes(extensao)) {
        setMensagemErro('Arquivo inválido')
        setRevelarMensagemErro(true)
        return
      }

      const reader = new FileReader()

      reader.onload = (evt) => {
        const data = evt.target.result
        //le os dados
        const readedData = XLSX.read(data, { type: 'array' })
        //transforma em um array de json
        const wsname = readedData.SheetNames[0]
        const ws = readedData.Sheets[wsname]
        const dados = XLSX.utils.sheet_to_json(ws, { header: 1 })
        //verifica se o esta mandando sao numeros e um arquivo certos
        if (!isNaN(parseInt(dados[0]))) {
          setArquivo(dados)
        }
      }

      reader.readAsArrayBuffer(file)
    })
  }

  async function handlerConsultarCliente(cdCliente) {
    setSpinAtivo(true)
    await api_gateway
      .get(
        cdCliente === undefined
          ? '/m1/consultar/cliente?painel_virtueyes=true&flBloqueio=true&n0_codigo_cliente=' +
              cliente
          : '/m1/consultar/cliente?painel_virtueyes=true&flBloqueio=true&n0_codigo_cliente=' +
              cdCliente
      )
      .then(function (response) {
        if (response.status == 200 && response.data.dados[0]) {
          itens.push(response.data.dados[0])
          handleLinhasSelecionadas(response.data.dados[0].length)
          //apenas ira rendeziar se for uma consulta pelo input
          setCliente('')
          setValidacaoCliente(false)
          setRevelarValidacao(false)
        } else {
          setValidacaoCliente(true)
        }
      })
      .catch(function () {
        setValidacaoCliente(true)
      })
    setSpinAtivo(false)
  }

  function handleSalvar() {
    if (itens.length > 0) {
      ColetaClickstream(1378) // 'dropAcoesSolicitacaBloquearVirtueyesConfirmar'
      handleBloquear()
    } else {
      setRevelarValidacao(true)
    }
  }

  async function enviarEmailParaClientes(itens) {
    const enviarEmailParaCliente = async (item_itens) => {
      const resposta = await api_gateway.post('/m1/servico/enviar_email', {
        ds_email: item_itens.ds_email,
        tipoEmail: 'aviso_bloqueio_cliente',
        ds_nome: item_itens.ds_nome
      })
      return resposta
    }

    return await Promise.all(
      itens.map((item_itens) => enviarEmailParaCliente(item_itens))
    )
  }

  async function handleBloquear() {
    setSpinAtivo(true)
    let clientesArray = []
    Promise.all(
      itens.map((item_cliente) => {
        clientesArray.push(item_cliente.cd_pav_cliente)
      })
    ).then(async () => {
      //FL_ACAO 1 E DE BLOQUEIOs
      await api_gateway
        .post('/m1/cadastrar/cliente_bloqueio ', {
          cd_pav_cliente: clientesArray,
          cd_pav_usuario: decryptJWT('codigo'),
          fl_acao: '1'
        })
        .then(async () => {
          if (enviarEmail) {
            enviarEmailParaClientes(itens).then(() => {
              setSpinAtivo(false)
              atualizarParent = true
              handleMensagemSucesso(false)
            })
          } else {
            setSpinAtivo(false)
            atualizarParent = true
            handleMensagemSucesso(false)
          }
        })
        .catch(() => {
          setSpinAtivo(false)
          setMensagemErro('Erro no cadastro de bloqueio')
          handleMensagemErro(false)
        })
    })
  }

  function botaoPressionado(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      handlerConsultarCliente()
    }
  }

  const eventosLinhas = {
    onClick: (e, row) => {
      setLinhaRemover(row.CD_SIMCARD)
    }
  }

  function handleLinhasSelecionadas(length) {
    setQuantidadeLinhasSelecionados(length || itens.length)
  }

  function handleRemoverLinha(cd_pav_cliente) {
    setRevelarMensagemAtencao(false)
    itens.forEach(function (e, index) {
      if (cd_pav_cliente == e.cd_pav_cliente) {
        itens.splice(index, 1)
      }
    })
    setItens(itens)
    handleLinhasSelecionadas()
  }

  function handleMensagemAtencao(confirmacao) {
    if (revelarMensagemAtencao === false) {
      setRevelarMensagemAtencao(true)
    } else {
      setRevelarMensagemAtencao(false)
    }
    if (confirmacao === true) {
      handleRemoverLinha(linhaRemover)
    }
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      handleCancelar()
    }
    if (confirmacao) {
      props.setRenderizar(!props.renderizar)
    }
  }

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function validarNumero(id, valor) {
    const filtro = /^[0-9]+$/
    if (valor === '' || filtro.test(valor)) {
      if (id === 'campo-texto-codigo') {
        setCliente(valor)
      }
    }
  }

  return (
    <Form ref={modal}>
      <div className="modal-bloquear-cliente fundo-cor-6">
        {spinAtivo && (
          <div className="componente-spinner-overlay">
            <div className="componente-spinner-container">
              <SpinerVeye />
            </div>
          </div>
        )}
        <Form.Row>
          <Col>
            <img
              className="icone-label-janela"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">Bloquear cliente</div>
            </Form.Label>
            <Button
              className="botao-fechar-janela"
              variant="danger"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </Button>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="nova-solicitacao-select-operadora">
              <Form.Label>
                <div className="fonte-cor-1 label-campo">Cód. cliente</div>
              </Form.Label>
              <div className="bloqueio-input-adicionar-cliente">
                <Form.Control
                  className="campo-texto-cor-3 campo-texto"
                  placeholder="Digite o código"
                  value={cliente}
                  onKeyDown={(e) => botaoPressionado(e)}
                  onChange={(e) =>
                    validarNumero('campo-texto-codigo', e.target.value)
                  }
                />
                {cliente.length > 0 && (
                  <Button
                    className="btn-img-bloqueio-input-adicionar-cliente"
                    onClick={() => handlerConsultarCliente()}
                  >
                    <img
                      className="img-bloqueio-input-adicionar-cliente"
                      src={adicionarMaisVerdeSemEllipse()}
                    />
                  </Button>
                )}
              </div>
              {validacaoCliente && (
                <p className="bloqueio-input-adicionar-cliente-alerta label-normal fonte-cor-3">
                  Cliente inválido
                </p>
              )}
              {revelarValidacao && (
                <span className="span-validacao-buscar-simcards-solicitacoes">
                  Selecione um cliente
                </span>
              )}
            </div>
          </Col>
          <Col>
            <div className="novo-bloqueio-importar-cliente">
              <Dropzone
                onDrop={(acceptedFiles) => handleLerArquivo(acceptedFiles)}
              >
                {({ getRootProps, getInputProps }) => (
                  <section>
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <Button className="btn-importar-cliente">
                        <div className="fonte-cor-4">Importar</div>
                        <img
                          className="img-importar-cliente"
                          src={importarArquivo()}
                        />
                      </Button>
                    </div>
                  </section>
                )}
              </Dropzone>
            </div>
          </Col>
        </Form.Row>
        {itens.length > 0 && (
          <>
            <Form.Row>
              <Col>
                <div className="container-tabela-modal-bloqueio-2">
                  <BootstrapTable
                    classes="tabela"
                    condensed
                    keyField="cd_pav_cliente"
                    data={itens}
                    columns={colunas}
                    rowEvents={eventosLinhas}
                    bootstrap4
                  />
                </div>
              </Col>
            </Form.Row>
            <Form.Row>
              <Col>
                <span className="fonte-cor-1 label-normal contador-linhas-acoes-dispositivos">
                  {quantidadeLinhasSelecionados} cliente(s) selecionado(s)
                </span>
              </Col>
            </Form.Row>
          </>
        )}
        <div className="btn-switch-enviar-aviso">
          <div className="flipswitch">
            <input
              type="checkbox"
              name="flipswitch"
              className="flipswitch-cb"
              id="switchCompartilhado"
              onChange={() => setEnviarEmail(!enviarEmail)}
            />
            <label className="flipswitch-label" htmlFor="switchCompartilhado">
              <div className="flipswitch-inner flipswitch-cor-1" />
              <div className="flipswitch-switch" />
            </label>
          </div>
          <div className="fonte-cor-1 label-campo">Enviar aviso</div>
        </div>
        <div className="label-alerta-arquivos-suportados-2 fonte-cor-3 label-alerta">
          {iconeAlerta} Os tipos de arquivos suportados são XLSX, XLS, CSV e
          TXT.
        </div>
        <div className="divisora-1" />
        <Form.Row className="espaco-ativar-linha">
          <Col>
            <Button
              className="botao-confirmar"
              variant="success"
              size="sm"
              onClick={() => handleSalvar()}
            >
              <div className="fonte-cor-4">Confirmar</div>
            </Button>
            <Button
              className="botao-cancelar"
              variant="success"
              size="sm"
              onClick={() => handleCancelar()}
            >
              <div className="fonte-cor-2">Cancelar</div>
            </Button>
          </Col>
        </Form.Row>
      </div>
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="Sua solicitação foi enviada."
              mensagemBotao="Continuar"
            />
          </div>
        </div>
      )}
      {revelarMensagemAtencao && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemAtencao
              handleMensagemAtencao={handleMensagemAtencao}
              mensagemTitulo="Remover linha?"
              mensagemBotao="Remover"
            />
          </div>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              centralizarBotao
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo="Erro"
              mensagemParagrafo1={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
    </Form>
  )
}
